/**
 * Serialize a Date as the YYYY-MM-DD the user actually sees.
 *
 * Date-range presets are built from local `Date`s (`Today` = `now`,
 * `endOfMonth` = 23:59:59 local). `toISOString()` converts to UTC first, so
 * west-of-UTC users querying in the afternoon would ask the API for
 * *tomorrow* and get an empty page, and east-of-UTC users would lose the
 * current day every morning. Always format the local calendar fields.
 */
export function toApiDate(d: Date): string {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
